export default __webpack_public_path__ + "static/media/uploader-medtronic6xG-3.71da1108.png";